import React from 'react';
import PropTypes from 'prop-types';

import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { css, StyleSheet } from 'aphrodite';

import {
  coolGrey,
  modernSalmon,
  modernSalmonBackground,
  positiveGreen,
  positiveGreenBackground,
} from 'lib/css/colors';

const getPercentageChange = percentageChange => {
  if (percentageChange > 0 || percentageChange < 0) {
    return percentageChange.toFixed(2) + '%';
  }
  return null;
};

const getPeriod = dateDifference => {
  if (dateDifference === 7) {
    return 'this week';
  } else if (dateDifference === 30) {
    return 'this month';
  }
  return `${dateDifference} days`;
};

function PercentageChange({ percentageChange, dateDifference, loading }) {
  const displayPercentageChange = getPercentageChange(percentageChange);
  const periodConsidered = getPeriod(dateDifference);

  if (loading) {
    return null;
  }

  if (!displayPercentageChange) {
    return <div className={css(styles.noChange)}>No change ({periodConsidered})</div>;
  }

  const isPositive = percentageChange > 0;
  const isNegative = percentageChange < 0;
  const arrowIcon = isPositive ? faArrowUp : faArrowDown;

  return (
    <div
      className={css(
        styles.container,
        isPositive && styles.positive,
        isNegative && styles.negative,
      )}
    >
      <FontAwesomeIcon icon={arrowIcon} className={css(styles.icon)} />
      <span className={css(styles.value)}>{displayPercentageChange}</span>
      <span className={css(styles.period)}>({periodConsidered})</span>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 10px',
    borderRadius: 16,
    fontSize: 12,
    fontWeight: 500,
  },
  positive: {
    color: positiveGreen,
    backgroundColor: positiveGreenBackground,
  },
  negative: {
    color: modernSalmon,
    backgroundColor: modernSalmonBackground,
  },
  icon: {
    fontSize: 10,
  },
  value: {
    fontWeight: 600,
  },
  period: {
    opacity: 0.85,
  },
  noChange: {
    fontSize: 12,
    color: coolGrey,
    opacity: 0.7,
  },
});

PercentageChange.propTypes = {
  percentageChange: PropTypes.number,
  dateDifference: PropTypes.number,
  loading: PropTypes.bool,
};

export default PercentageChange;
